(function () {
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var root = document.querySelector('[data-ll-footer-newsletter]');
  if (!root) return;

  var form = root.querySelector('#ContactFooter');
  if (!form) return;

  var companyId = (root.getAttribute('data-company-id') || 'SL8F76').trim();
  var listId = (root.getAttribute('data-list-id') || 'Sek8Sd').trim();
  var emailInput = form.querySelector('input[name="contact[email]"]');

  function subscribeKlaviyo(email) {
    if (!companyId) return;

    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'LoveLab Footer',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                subscriptions: {
                  email: { marketing: { consent: 'SUBSCRIBED' } }
                }
              }
            }
          }
        }
      }
    };
    if (listId) {
      payload.data.relationships = {
        list: { data: { type: 'list', id: listId } }
      };
    }

    // Fire-and-forget so Shopify CAPTCHA + form submit stay intact.
    // keepalive lets the request finish after page navigation.
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        revision: '2025-01-15'
      },
      body: JSON.stringify(payload),
      keepalive: true
    }).catch(function (err) {
      try {
        console.warn('[ll-footer-newsletter] Klaviyo subscribe error', err);
      } catch (e) {}
    });
  }

  function identifyKlaviyo(email) {
    try {
      window.klaviyo = window.klaviyo || [];
      window.klaviyo.push(['identify', { email: email }]);
      window.klaviyo.push(['track', 'Signed Up for Newsletter', { source: 'footer' }]);
    } catch (e) {}
  }

  form.addEventListener('submit', function () {
    var email = (emailInput && emailInput.value ? emailInput.value : '').trim();
    if (!EMAIL_RE.test(email)) return;
    subscribeKlaviyo(email);
    identifyKlaviyo(email);
  });
})();
